import React from "react";

import { ErrorMessage, SingleSelect, TextField } from "widgets";
import { PRODUCT_OFFERINGS } from "constants/config";

import styles from "./AddPackageFeatureOffering.module.scss";

const Field = ({ title, component, error }) => (
  <div className={styles.fieldsDisplay}>
    <span className={styles.title}>{title}</span>
    {component}
    {error && <ErrorMessage>{error}</ErrorMessage>}
  </div>
);

const AddProductOffering = (props) => {
  const { offering, handleProductFeatureOffering, errors } = props;

  return (
    <div className={styles.offeringContainer}>
      <div className={styles.fieldContainer}>
        <Field
          title="Product Offering"
          component={
            <SingleSelect
              menuItems={PRODUCT_OFFERINGS}
              placeholder="Select Offering Name"
              value={offering.productOffering || ""}
              handleChange={(event) =>
                handleProductFeatureOffering({
                  ...offering,
                  productOffering: event.target.value,
                })
              }
            />
          }
          error={errors && errors?.productOffering?.value}
        />
        <Field
          title="Quantity"
          component={
            <TextField
              value={offering.quantity || ""}
              placeholder="Enter quantity"
              onChange={(event) =>
                handleProductFeatureOffering({
                  ...offering,
                  quantity: event.target.value,
                })
              }
            />
          }
          error={errors ? errors.quantity : ""}
        />
      </div>

      <div className={styles.description}>
        <Field
          title="Product Offering Description"
          component={
            <textarea
              value={offering.description || ""}
              placeholder="Enter description"
              onChange={(event) =>
                handleProductFeatureOffering({
                  ...offering,
                  description: event.target.value,
                })
              }
              className={styles.descriptionTextField}
            />
          }
          error={errors ? errors.description : ""}
        />
      </div>
    </div>
  );
};

export default AddProductOffering;
